import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { de, en, nl } from './assets/locales';

const options = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },

  debug: process.env.NODE_ENV === 'development',

  resources: {
    nl: {
      common: nl.nl,
    },
    en: {
      common: en.en,
    },
    de: {
      common: de.de,
    },
  },

  fallbackLng: 'en',

  ns: ['common'],

  defaultNS: 'common',

  react: {
    useSuspense: false,
  },
};

i18n.use(LanguageDetector).use(initReactI18next).init(options);

export default i18n;
